import React from "react";
import { Flex, VerticalDivider } from "@100mslive/react-ui";
import { ParticipantCount } from "./ParticipantList";
import { Logo, SpeakerTag } from "./HeaderComponents";
import { StreamActions } from "./StreamActions";
import { selectLocalPeer, useHMSStore } from "@100mslive/react-sdk";

export const ConferencingHeader = ({ isPreview }) => {
  const localPeer = useHMSStore(selectLocalPeer);
  return (
    <Flex
      justify="between"
      align="center"
      css={{ position: "relative", height: "100%" }}
    >
      <Flex align="center" css={{ position: "absolute", left: "$10" }}>
        <Logo />
        <VerticalDivider css={{ ml: "$8" }} />
        {!isPreview ? <SpeakerTag /> : null}
      </Flex>

      <Flex
        align="center"
        css={{
          position: "absolute",
          right: "$10",
          gap: "$4",
        }}
      >
        <StreamActions />
        {/* <ParticipantCount /> */}
        {localPeer?.roleName === "moderator" ? <ParticipantCount /> : null}
      </Flex>
    </Flex>
  );
};
